module.exports = __webpack_public_path__ + "img/image_1.5344bdac.png";